// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'
import toast from 'react-hot-toast'
import { baseUrl } from '../../../../../app.config'

export const getPromoCodeList = createAsyncThunk(
  'promo/getPromoCodeList',
  async () => {
    const response = await axios.get(baseUrl() + '/promo/list')
    return {
      promoCodeLists: response.data.data
    }
  }
)


export const createCustomPromo = createAsyncThunk(
  'promo/createCustomPromo',
  async ({ code, discount, usageLimit, expiryDate }, { dispatch }) => {
    try {
      const res = await axios.post(baseUrl() + '/promo/create-custom', {
        code,
        discount,
        usageLimit,
        expiryDate
      })
      toast.success('Promo created')
      dispatch(getPromoCodeList())
      return res.data
    } catch (err) {
      toast.error(err?.response?.data?.message)
      throw err
    }
  }
)

/* CREATE AUTO */
export const createAutoPromo = createAsyncThunk(
  'promo/createAutoPromo',
  async ({ discount, usageLimit, expiryDate }, { dispatch }) => {
    try {
      const res = await axios.post(baseUrl() + '/promo/create-auto', {
        discount,
        usageLimit,
        expiryDate
      })
      toast.success('Promo created')
      dispatch(getPromoCodeList())
      return res.data
    } catch (err) {
      toast.error(err?.response?.data?.message)
      throw err
    }
  }
)


/* UPDATE */
export const updatePromo = createAsyncThunk(
  'promo/updatePromo',
  async ({ id, discount, usageLimit, expiryDate }, { dispatch }) => {
    try {
      const res = await axios.put(baseUrl() + `/promo/update/${id}`, {
        discount,
        usageLimit,
        expiryDate
      })
      toast.success('Promo updated')
      dispatch(getPromoCodeList())
      return res.data
    } catch (err) {
      toast.error(err?.response?.data?.message)
      throw err
    }
  }
)

/* DELETE */
export const deletePromo = createAsyncThunk(
  'promo/deletePromo',
  async ({ id }, { dispatch }) => {
    try {
      const res = await axios.delete(baseUrl() + `/promo/delete/${id}`)
      toast.success('Promo deleted')
      dispatch(getPromoCodeList())
      return id
    } catch (err) {
      toast.error(err?.response?.data?.message)
      throw err
    }
  }
)


export const PromoCodes = createSlice({
  name: 'promo',
  initialState: {
    promoCodeLists: [],
    selected: null,
    loader: true,
  },
  reducers: {
    selectPromo: (state, action) => {
      if (action.payload === null) {
        state.selected = null
      } else {
        state.selected = action.payload
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPromoCodeList.fulfilled, (state, action) => {
        state.promoCodeLists = action.payload.promoCodeLists
        state.loader = false
      })
      .addCase(getPromoCodeList.pending, (state) => {
        state.loader = true
      })
  }
})

export const { selectPromo } = PromoCodes.actions

export default PromoCodes.reducer
